import * as React from 'react'
import styled from 'styled-typed'
import { ActionButton } from 'uiComponents/buttons'
import { ModalDialog, ModalDialogTitle } from 'uiComponents/popups/modal'
import { StyledATag } from 'uiComponents/typography'
import { Trans, useTranslation } from 'translations'

const Container = styled.div`
    width: 28em;
`
const NavigationSection = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 2.5em;
`

const ContentBlock = styled.div`
    margin-bottom: 1.5em;
`

const ContentBody = styled.span`
    font-size: 0.875rem;
    line-height: 1.5rem;
`

const ContentFooter = styled.span`
    font-size: 0.75rem;
    line-height: 1rem;
`

interface DialogProps {
    audienceName: string
    title: string
    buttonText: string
    onDraft?: () => void
    onCancel?: () => void
    onConfirm: () => void
}

export function AudienceModal({ audienceName, title, buttonText, onConfirm, onCancel, onDraft }: DialogProps) {
    const { t } = useTranslation()
    return (
        <ModalDialog onDismiss={onCancel} interactive fromTop="20%">
            <Container>
                <ModalDialogTitle>{title}</ModalDialogTitle>
                <ContentBlock>
                    <ContentBody>
                        <Trans
                            i18nKey="uiComponents.studio.audienceModal.includesAllUsers"
                            values={{ audienceName }}
                            components={{ strong: <strong /> }}
                        />
                    </ContentBody>
                </ContentBlock>
                <ContentBlock>
                    <ContentBody>
                        <Trans
                            i18nKey="uiComponents.studio.audienceModal.gdprNotice"
                            components={{ strong: <strong /> }}
                        />
                    </ContentBody>
                </ContentBlock>
                <ContentFooter>
                    <Trans
                        i18nKey="uiComponents.studio.audienceModal.moreInformation"
                        components={{ anchor: <StyledATag target="_blank" href="https://support.convious.com/help/" /> }}
                    />
                </ContentFooter>
                <NavigationSection>
                    {!!onCancel && (
                        <ActionButton size="large" secondary onClick={onCancel}>
                            {t('common.cancel')}
                        </ActionButton>
                    )}
                    {!!onDraft && (
                        <ActionButton size="large" kind="default" style={{ marginLeft: '2em' }} onClick={onDraft}>
                            {t('uiComponents.studio.audienceModal.saveAsDraft')}
                        </ActionButton>
                    )}
                    <ActionButton size="large" kind="default" style={{ marginLeft: '2em' }} onClick={onConfirm}>
                        {buttonText}
                    </ActionButton>
                </NavigationSection>
            </Container>
        </ModalDialog>
    )
}
